<template>
  <v-dialog v-model="modal" max-width="800" persistent>
    <v-form ref="form" @submit.stop.prevent>
      <v-card>
        <v-card-title> Demande de rattachement </v-card-title>
        <v-card-text>
          <p>
            Vous êtes sur le point de demander votre rattachement à l'association
            {{ nom }}.
          </p>
          <p>
            Ce rattachement vous permettra de réaliser de manière dématérialisée un grand
            nombre d'actions concernant l'association (gestion et consultation en ligne).
          </p>
          <p>
            Afin que le tribunal puisse valider votre demande, merci de joindre une pièce
            d'identité et le cas échéant tout justificatif vous conférant un pouvoir de
            représentation de l'association (PV d'AG, pouvoir général ou spécial de
            représentation...).
          </p>
          <v-text-field
            dense
            filled
            label="Fonction"
            v-model="fonction"
            :rules="[serverRule('fonction')]"
            hint="Veuillez saisir votre fonction dans l'association"
            data-testid="fonction"
          />
          <v-row dense>
            <v-col cols="12">
              <a-plain-text-component :rules="[serverRule('documents'), taillesMaxRules]">
                <span class="am-t2 bold"> Annexes</span>
              </a-plain-text-component>
            </v-col>
            <v-col cols="12">
              <div class="d-flex justify-center">
                <v-btn data-testid="ajouter" @click="ajouter"> Ajouter une annexe </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6" v-for="(a, i) in annexes" :key="`${i}`">
              <a-document-card
                :value="a"
                :index="i"
                @supprimer="supprimer(i)"
                @telecharge="telecharge(a)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-demande-rattachement" ref="non" color="primary" @click="demande" :loading="working">
            Valider
          </v-btn>
          <v-btn data-testid="annuler-demande-rattachement" @click="ferme" :disabled="working">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <a-document-dialog ref="dialog" typesDocuments="rattachement" />
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import { associationService, requeteService } from "@/services";
import { mapGetters } from "vuex";
import bytes from "@/filters/bytes";

export default {
  mixins: [makeRules({ inject: false }), makeRemoteWorker()],
  data() {
    return {
      association: null,
      nom: null,
      fonction: null,
      annexes: [],
      modal: false,
      url: null,
    };
  },
  beforeDestroy() {
    this.destroyURL();
  },
  computed: {
    ...mapGetters({
      tailleMax: "fichiers/tailleMax",
    }),
    taillesMaxRules() {
      if (this.totalSuperieurTailleMax) {
        return `La taille des fichiers dépasse la limite de ${bytes(this.tailleMax)}`;
      }
      return true;
    },
    tailleAnnexesTotale() {
      return this.annexes.map(a => a.taille).reduce((a, b) => a + b, 0);
    },
    totalSuperieurTailleMax() {
      return this.tailleAnnexesTotale > this.tailleMax;
    },
  },
  methods: {
    ajouter() {
      let tmpDoc = null;
      this.$refs.dialog.nouveau(
        doc => {
          tmpDoc = doc;
          const { fichier, nom, journal, type, sousType, date } = doc;
          return requeteService.validationDocument(
            "rattachement",
            { nom, journal, type, sousType, date },
            fichier
          );
        },
        () => {
          // on utilise le fichier temporaire pour le TS car les fichiers n'existent pas coté serveur
          this.annexes.push({ ...tmpDoc, actionsPossible: true });
        }
      );
    },
    supprimer(index) {
      this.annexes.splice(index, 1);
    },
    telecharge(a) {
      this.destroyURL();
      this.url = URL.createObjectURL(a.fichier);
      window.open(this.url, "_blank");
    },
    destroyURL() {
      if (this.url) {
        window.URL.revokeObjectURL(this.url);
        this.url = null;
      }
    },
    ouvre(association, nom, callback) {
      this.association = association;
      this.nom = nom;
      this.fonction = null;
      this.annexes = [];
      this.callback = callback;
      this.modal = true;
    },
    ferme() {
      this.modal = false;
    },
    demande() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.demandeRattachement(
            this.association,
            { fonction: this.fonction },
            this.annexes
          );
        },
        callback(etat) {
          this.ferme();
          this.callback(etat);
        },
        successText: "La demande de rattachement a été envoyée.",
        errorText: "Erreur durant l'envoi de la demande de rattachement.",
      });
    },
  },
};
</script>
